import { UserInterface } from './models';

export function emailPreviewSignature(user: UserInterface): string {
  return `<br>
<table style="border-collapse: collapse; background-color: #ffffff; color: #00325d; padding: 20px; width: 100%; max-width: 600px;">
  <tbody>
    <tr>
      <td style="vertical-align: top; width: 84px; padding-right: 20px; border-right: 1pt solid windowtext;">
        <img src="assets/emailPreview/c-logo.webp" border="0" height="68" alt="COLUMBUS" style="width: 0.7291in; height: 0.7083in;">
      </td>
      <td style="vertical-align: top; width: 445px; padding: 0 5.4pt;">
        <div style="margin: 0; font-size: 10pt; font-family: poppins, sans-serif; color: #00325d; font-weight: bold;">
${user?.username}
        </div>
        <div style="margin: 0; font-size: 9pt; font-family: poppins, sans-serif; color: #00325d;">
${user?.title}
        </div>
        <div style="margin: 0; font-size: 9pt; font-family: poppins, sans-serif;">
          <span style="font-size: 5pt;"><br /></span>
          M ${user?.tel}
        </div>
        <div style="margin: 0; font-size: 9pt; font-family: poppins, sans-serif;">
          E <a href="mailto:${user?.email}" style="text-decoration: underline;">${user?.email}</a>
        </div>
        <div style="margin: 0; font-size: 9pt; font-family: poppins, sans-serif;">
          <span style="font-size: 5pt;"><br /></span>
          COLUMBUS Reisen GmbH & Co KG.
        </div>
        <div style="margin: 0; font-size: 9pt; font-family: poppins, sans-serif;">
          Handelskai 265 1020 Vienna, Austria
        </div>
        <div style="margin: 0; font-size: 9pt; font-family: poppins, sans-serif; text-decoration: underline;">
          <a href="http://www.columbus-cruise-management.com/" style="text-decoration: none;">www.columbus-cruise-management.com</a>
        </div>
        <div style="margin: 0; font-size: 5pt; font-family: poppins, sans-serif;">
          <br />
        </div>
        <div style="margin: 0; font-size: 11pt; font-family: poppins, sans-serif; display: flex; align-items: center;">
          <a href="https://www.facebook.com/columbus.reisen.at" style="margin-right: 10px;">
            <img border="0" height="19" alt="Facebook" style="width: 0.1979in; height: 0.1979in" src="assets/emailPreview/f-logo.webp">
          </a>
          <a href="https://www.instagram.com/columbus_reisen/" style="margin-right: 10px;">
            <img border="0" height="19" alt="Instagram" style="width: 0.1979in; height: 0.1979in" src="assets/emailPreview/i-logo.webp">
          </a>
          <a href="https://www.linkedin.com/company/columbus-ihr-reiseb%c3%bcro">
            <img border="0" height="19" alt="LinkedIn" style="width: 0.1979in; height: 0.1979in" src="assets/emailPreview/l-logo.webp">
          </a>
        </div>
      </td>
    </tr>
  </tbody>
</table>
<div style="margin: 0; font-size: 5pt; font-family: poppins, sans-serif;">
  <br>
</div>
<div style="margin: 0; font-size: 8pt; font-family: poppins, sans-serif; text-transform: uppercase;">
  uid: atu 10903209, fn nr.: 5351w, handelsgericht wien
</div>

<br>
<br>
`;
}
